// OverviewTab.js
import React from 'react';
import { useTranslation } from 'react-i18next';
import videoMimetika from '../../../img/video_web_mimetika_800x400px.mp4';
//import videoMimetikaGif from '../../../img/video_web_mimetika_400x200px.webp';
import videoMimetikaGif from '../../../img/video_web_mimetika_480x270px.webp';

// HorizontalBar Component
const HorizontalBar = ({ label, value }) => {
    const safeValue = typeof value === 'number' ? value : 0;
    return (
        <div className="text-white">
          <div className="gradient-bar mb-3 relative">
            <div className="bar-label text-xs font-light pb-2">{label}</div>
            <div className="flex items-center m-0">
              <div className="progress-bar relative" style={{ flex: '0 0 91.666667%' }}>
                <div
                    className="progress-bar-gradient"
                    style={{
                      width: `${safeValue * 100}%`,
                      '--progress-value': safeValue || 1 // Avoid division by zero in CSS
                    }}
                ></div>
              </div>
              <div className="md:ml-3 flex-grow text-right text-sm whitespace-nowrap">
                { Math.round(safeValue * 100) }%
              </div>
            </div>
          </div>
        </div>
    );
};


const isSafariOrIOS = (() => {
  if (typeof navigator === 'undefined' || typeof window === 'undefined') return false;

  const ua = navigator.userAgent || '';
  const vendor = navigator.vendor || '';

  // 1) Classic iOS (iPhone, iPod, older iPad)
  const isIOSDevice = /iPad|iPhone|iPod/.test(ua) && !window.MSStream;

  // 2) iPadOS 13+ (reports as Mac but has touch)
  const isMacLike = /Macintosh/.test(ua) || navigator.platform === 'MacIntel';
  const hasTouch = typeof navigator.maxTouchPoints === 'number' && navigator.maxTouchPoints > 1;
  const isIPadOSDesktopUA = isMacLike && hasTouch;

  // 3) macOS Safari (real Safari, not Chrome/Edge/etc)
  const isSafariVendor = vendor === 'Apple Computer, Inc.'; // Safari & WebView
  const isSafariInUA = ua.includes('Safari');
  const isChromiumBased =
    ua.includes('Chrome') ||
    ua.includes('Chromium') ||
    ua.includes('CriOS') ||   // Chrome iOS
    ua.includes('Edg') ||     // Edge
    ua.includes('OPR') ||     // Opera
    ua.includes('Brave');

  const isMacSafari = isSafariVendor && isSafariInUA && !isChromiumBased;

  return isIOSDevice || isIPadOSDesktopUA || isMacSafari;
})();


const OverviewTab = ({
description,
eyeMovementFactor,
coverage
}) => {
    const { i18n, t } = useTranslation();

    const getCoverageInfo = (value) => {
        if (value >= 0 && value <= 0.05) {
            return  t('RepeatTest');
        } else if (value > 0.05 && value <= 1) {
            return t('Satisfactory');
        //} else if (value > 0.60 && value <= 1) {
        //    return t('Excellent');
        } else {
            return t('InvalidValue');
        }
    };


  return (
      <div className="grid grid-cols-12 gap-2 lg:gap-6 m-0 px-1 md:px-3">
        {/* Video Plot Section */}
        <div className="col-span-12 xl:col-span-6">
          <div className="plot-container w-full flex justify-center items-center">
              <div className="w-full">
            {isSafariOrIOS  ? (
              <img
                src={videoMimetikaGif}
                alt="Mimetika overview"
                className="w-full h-auto object-cover rounded-lg"
              />
            ) : (
              <video
                className="w-full h-auto object-cover rounded-lg"
                controls
                autoPlay={true}
                muted
                loop
                playsInline
                preload="auto"
                webkit-playsinline="true" // <- Safari iOS, not used as WEBP version shown on IOS
                x5-playsinline="true"     // <- Android
              >
                      <source src={videoMimetika} type="video/mp4" />
                      Your browser does not support the video tag.
                  </video>
            )}
              </div>
          </div>
        </div>
        {/* Second Column for Additional Details */}
        <div className="col-span-12 xl:col-span-6">
          <div className="h-full flex justify-content-center align-items-center">
            <div className="m-auto relative w-full">
              {/* Horizontal Bars */}
              <div className="card border border-white pt-2 pb-2 px-4 md:px-4 mt-3 rounded-md text-left w-full">
                <div className="text-white uppercase text-sm sm:font-medium pt-2 pb-3">
                  {t('eyeMovementFactor')}
                </div>
                <HorizontalBar label={t('far')} value={eyeMovementFactor?.far} />
                <HorizontalBar label={t('intermediate')} value={eyeMovementFactor?.intermediate} />
                <HorizontalBar label={t('near')} value={eyeMovementFactor?.near} />
                <HorizontalBar label={t('general')} value={eyeMovementFactor?.combined} />
              </div>
              <div className="mt-3 sm:flex justify-content-end align-items-center">
                  <div className="text-white uppercase text-sm sm:font-medium sm:mr-3">{t('StimulusTracking')}</div>
                  <div className="mt-2 sm:mt-0 sm:text-right">
                      <input
                      value={getCoverageInfo(coverage)}
                      readOnly={true}
                      className="border-grey-ligth shadow text-center text-sm appearance-none border rounded w-60 py-2 px-3"
                      id="motion"
                      type="text"/>
                  </div>
              </div>
            </div>
          </div>
        </div>
      </div>
  );
};

export default OverviewTab;
